import MiniButton from "../../components/MiniButton";
import { colorsList } from "../../data/colorsList";
import ClearIcon from "@mui/icons-material/Clear";

export default function InfoMenu({ openBox2, buttonsMenu, scrollMenu }) {
  return (
    <div
      style={{
        backgroundColor: colorsList.lightGrey,
        display: "flex",
        flexDirection: "row",
        padding: 5,
        borderBottom: "2px solid " + colorsList.darkGrey,
      }}
    >
      <div
        ref={scrollMenu}
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 5,
          flex: 1,
          overflowX: "auto",
          marginRight: 5,
          scrollbarWidth: "none",
          scrollBehavior: "smooth",
        }}
      >
        {buttonsMenu.map(
          ({ active, ...rest }, index) =>
            active && <MiniButton key={index} {...rest} />
        )}
      </div>
      <MiniButton
        Icon={ClearIcon}
        onClick={() => openBox2(false)}
        color={colorsList.red}
      />
    </div>
  );
}
